import fetch from 'isomorphic-fetch';
import { result, intersection } from 'lodash';
import {
    sortPagesByFeatured,
    sortPagesByName,
    sortPagesByDate
} from '../utils/sort-helper';
import { groupArrayByPrefix } from '../utils/util';

var DATA = null;
var lastSearch = null;
var lastSearchResult = null;

function onDocumentReady() {
    initialize(document.getElementById('content-exchange-data'));
}

function initialize(dataElement) {
    if (!dataElement) {
        return false;
    }

    DATA = JSON.parse(dataElement.textContent).map(p => ({
        id: p['@id'],
        title: p.title,
        date: p['date.created'],
        tags: result(p, 'tags.tag', []).map(t => t.title),
        url: getMindTouchPageLocalURL(p)
    }));
}

function getMindTouchPageLocalURL(page) {
    let host = $('#content-exchange-data').attr('data-home');
    let path = page.path['#text'].replace(/^Content_Exchange\//gi, '');

    return `${host}/content-exchange/${path}/`.toLowerCase();
}

function searchContentExchangePages(pages, searchTerm) {
    if (!searchTerm) {
        return Promise.resolve(pages);
    }

    if (searchTerm === lastSearch) {
        return Promise.resolve(lastSearchResult);
    } else {
        let homeurl = $('#content-exchange-data').attr('data-home');
        let url = `${homeurl}/wp-json/cx/search/${searchTerm}`;
        return fetch(url)
            .then(r => r.json())
            .then(pageIds => {
                lastSearch = searchTerm;
                lastSearchResult = pages.filter(p => pageIds.includes(p.id));

                return lastSearchResult;
            });
    }
}

function pageMatchesFilter(page, filter) {
    return filter.reduce(
        (pass, tags) => pass && intersection(tags, page.tags).length > 0,
        true
    );
}

function filterContentExchangePages(pages, filterState) {
    let ret = pages;

    if (filterState.length > 0) {
        let tagGroups = groupArrayByPrefix(filterState, ':');

        ret = pages.filter(page => pageMatchesFilter(page, tagGroups));
    }

    return Promise.resolve(ret);
}

function sortContentExchangePages(pages, sortBy, sortDir) {
    let sortFunction = null;
    switch (sortBy) {
        case 'featured':
            sortFunction = sortPagesByFeatured;
            break;

        case 'name':
            sortFunction = sortPagesByName;
            break;

        case 'date':
            sortFunction = sortPagesByDate;
            break;

        default:
            sortFunction = () => 0;
            break;
    }

    let sortedData = pages.sort(sortFunction);

    if (sortDir === 'desc') {
        sortedData = sortedData.reverse();
    }

    return Promise.resolve(sortedData);
}

function paginateContentExchangePages(pages, pageNumber, postsPerPage) {
    let total = pages.length;
    let startIndex = (pageNumber - 1) * postsPerPage;

    return Promise.resolve({
        results: [...pages].splice(startIndex, postsPerPage),
        total
    });
}

export function getContentExchangePages({
        search,
        filter,
        sortBy,
        sortDir,
        page,
        postsPerPage
    }) {
    let applyFilter = pages => filterContentExchangePages(pages, filter);

    let applySort = pages => sortContentExchangePages(pages, sortBy, sortDir);

    let applyPagination = pages =>
        paginateContentExchangePages(pages, page, postsPerPage);

    return searchContentExchangePages([...DATA], search)
        .then(applyFilter)
        .then(applySort)
        .then(applyPagination);
}

document.addEventListener('DOMContentLoaded', onDocumentReady);
